import { render } from "./podcast-detail.vue?vue&type=template&id=1b914037"
import script from "./podcast-detail.vue?vue&type=script&lang=js"
export * from "./podcast-detail.vue?vue&type=script&lang=js"

import "./podcast-detail.vue?vue&type=style&index=0&id=1b914037&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__